/* epi-legacy-init.js – PageSpeed B3 (23.09.2026)
   Ehemalige Inline-Blöcke aus layout/theme.liquid. Läuft deferred nach jquery.min.js und slick.min.js,
   Start über window.epiReady (siehe theme.liquid), nur für Elemente, die auf der Seite existieren. */
window.epiReady(function ($) {
  if (!$ || !$.fn) return;

  /* Blog-Slider (home-featured-blogs, blog-page-custom) */
  if ($.fn.slick && $('.blog-slider').length && !$('.blog-slider').hasClass('slick-initialized')) {
      $('.blog-slider').slick({
      dots: false,
      infinite: true,
      speed: 1000,
      arrow:false,
      slidesToShow: 3,
      autoplay:false,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding:'20px',
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding:'20px',
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    	$(".prev-btn").click(function () {
    		$(".blog-slider").slick("slickPrev");
    	});

    	$(".next-btn").click(function () {
    		$(".blog-slider").slick("slickNext");
    	});
    	$(".prev-btn").addClass("slick-disabled");
    	$(".blog-slider").on("afterChange", function () {
    		if ($(".slick-prev").hasClass("slick-disabled")) {
    			$(".prev-btn").addClass("slick-disabled");
    		} else {
    			$(".prev-btn").removeClass("slick-disabled");
    		}
    		if ($(".slick-next").hasClass("slick-disabled")) {
    			$(".next-btn").addClass("slick-disabled");
    		} else {
    			$(".next-btn").removeClass("slick-disabled");
    		}
    	});
  }

  /* Wirkstoff-Slider (product-page-slide) – die Section re-initialisiert im Theme-Editor selbst */
  if ($.fn.slick && $('.product-boost').length && !$('.product-boost').hasClass('slick-initialized')) {
      $('.product-boost').slick({
      dots: true,
      infinite: true,
      speed: 100,
      arrow:false,
      slidesToShow: 3,
       centerMode: true,
        centerPadding:'0',
        autoplay:false,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            adaptiveHeight: true
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            centerPadding:'70px',
            slidesToScroll: 1,
            adaptiveHeight: true
          }
        }, 
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerPadding:'70px',
            slidesToScroll: 1,
            adaptiveHeight: true
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }

  /* "Mehr anzeigen" der Collection-Beschreibung */
  if ($('.readmore').length) {
            //   $('.fulltext').hide();
		
            $('.readmore').insertAfter( '.collection-discritpion' );

            $('.readmore').click(function (event) {
              event.preventDefault();
              var description = document.querySelector('.collection-discritpion');
              console.log(description.style.height)
              if (description.style.height === ''){
                description.style.height = 'auto';
              } else if (description.style.height === 'auto'){
                description.style.height = '';
              }
              else{
                description.style.height = '92px';
              }

              $(this).text($(this).text() == 'Weniger Anzeigen' ? 'Mehr Anzeigen' : 'Weniger Anzeigen');
            });
  }

  /* Cart-Drawer-Buttons (Alt-Markup) */
  if ($('.cart-drawer-btn, .cart-drawer-close-btn').length) {
    	var $drawerRight = $('.cart-drawer-right');
    	var $cart_list = $('.cart-drawer-btn, .cart-drawer-close-btn');
		
    	$cart_list.click(function() {
    		$(this).toggleClass('active');
    		$('body').toggleClass('cart-drawer-pushtoleft');
    		$drawerRight.toggleClass('cart-drawer-open');
    	});
  }
});
